import { render, staticRenderFns } from "./PravicePridelava.vue?vue&type=template&id=6d2f2619&scoped=true&"
import script from "./PravicePridelava.vue?vue&type=script&lang=js&"
export * from "./PravicePridelava.vue?vue&type=script&lang=js&"
import style0 from "./PravicePridelava.vue?vue&type=style&index=0&id=6d2f2619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f2619",
  null
  
)

export default component.exports